(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wishit-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrappers = document.querySelectorAll(".wishit-marquee-wrapper");
    wrappers.forEach(function (w) {
      var inner = w.querySelector(".wishit-marquee");
      if (inner) w.style.height = inner.offsetHeight + "px";
    });
    // PERF: pause marquee animation when off-screen (saves compositor work on scroll).
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle("marquee-paused", !e.isIntersecting);
        });
      }, { rootMargin: "100px" });
      wrappers.forEach(function (w) { io.observe(w); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
